import { render, staticRenderFns } from "./Modal6.vue?vue&type=template&id=39829ba2&scoped=true&"
import script from "./Modal6.vue?vue&type=script&lang=js&"
export * from "./Modal6.vue?vue&type=script&lang=js&"
import style0 from "./Modal6.vue?vue&type=style&index=0&id=39829ba2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39829ba2",
  null
  
)

export default component.exports